<template>
  <div class="user" :class="classNames" v-if="name">{{name}}<span v-if="showLoginOutBtn" class="user__out" @click="loginOut">退出</span></div>
</template>

<script>
import { getUser } from '@utils/auth';
import { env } from '@utils';
export default {
  props: {
    phone: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    showLoginOutBtn: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      name: '',
    };
  },
  computed: {
    classNames() {
      return {
        'user--course': this.type === 'course',
        'user--camp': this.type === 'camp',
      };
    }
  },
  watch: {
    phone: {
      handler(val) {
        this.setName();
      },
      immediate: true
    }
  },
  methods: {
    loginOut() {
      this.$emit('loginOut');
      window.localStorage.clear();
      if (this.redirectUrl) {
        window.location.replace(this.redirectUrl);
      } else {
        location.reload();
      }
    },
    setName() {
      if (window && window.__wxjs_environment === 'miniprogram') {
        return;
      }
      // 是否有通过props传入的phone
      let number = this.phone;
      // phone不存在且非客户端内，去本地缓存中去取
      if (!number && !env.isApp) {
        try {
          const { phone } = JSON.parse(getUser()) || {};
          number = phone;
        } catch (error) {

        }
      }
      if (!number) {
        return;
      }
      this.name = number.replace(number.substring(3, 7), '****');
    }
  }
};
</script>

<style lang="stylus" scoped>
.user{
  height 28px;
  line-height 28px;
  font-size 14px;
  color #fff;
  background rgba(0,0,0,.4);
  border-radius 14px 0 0 14px;
  padding 0 12px;
  position fixed;
  top 20px;
  right: 0;
  z-index 10;
  cursor pointer;
  &.user--course {
    top 14px;
    height: 36px;
    padding 0 9px 0 18px;
    line-height 36px;
    font-size 16px;
    border-radius: 100px 0px 0px 100px;
  }
  &.user--camp {
    top: 10px;
    height: 34px;
    line-height: 34px;
    padding 0 13px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 100px 0px 0px 100px;
    .user__out {
      color: #C2C2CC;
      font-family: PingFang SC;
      font-size: 13px;
    }
  }
  .user__out {
    padding-left: 10px;
  }
}
</style>